import { LocationDescriptor } from 'history';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';

export const PrivateRoute = ({
  canActivate,
  redirectTo,
  ...props
}: PrivateRouteProps) =>
  canActivate ? <Route {...props} /> : <Redirect to={redirectTo} />;

interface PrivateRouteProps extends React.ComponentProps<typeof Route> {
  canActivate: boolean;
  redirectTo: LocationDescriptor;
}

export default PrivateRoute;
